var _path, _rect, _path2, _path3, _rect2, _g, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForceFeedbackThumbnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 136,
    viewBox: "0 0 168 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 16C16.75 7.57766 23.5777 0.75 32 0.75H136C144.422 0.75 151.25 7.57766 151.25 16V120C151.25 128.422 144.422 135.25 136 135.25H32C23.5777 135.25 16.75 128.422 16.75 120V16Z",
    fill: "#EEF3F9",
    stroke: "url(#paint0_linear_6830_23424)",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 67,
    fill: "url(#paint1_linear_6830_23424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 107C28 104.791 29.7909 103 32 103H136C138.209 103 140 104.791 140 107V121C140 123.209 138.209 125 136 125H32C29.7909 125 28 123.209 28 121V107Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 40C31.75 35.9959 34.9959 32.75 39 32.75H129C133.004 32.75 136.25 35.9959 136.25 40V87C136.25 91.0041 133.004 94.25 129 94.25H39C34.9959 94.25 31.75 91.0041 31.75 87V40Z",
    fill: "white",
    stroke: "#C5C5C5",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6830_23424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 69,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 72.8564,
    width: 16,
    height: 16,
    transform: "rotate(-12.1089 112.9 72.8564)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6830_23424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.399 85.5663L118.578 77.0763L121.449 72.7439C121.62 72.4803 121.834 72.2981 122.091 72.1972C122.348 72.0968 122.604 72.0873 122.86 72.1688C123.119 72.2611 123.326 72.4298 123.48 72.6748C123.635 72.9197 123.707 73.2026 123.697 73.5235L123.597 75.9995L127.639 75.1324C127.997 75.0555 128.344 75.1258 128.68 75.3433C129.017 75.5607 129.224 75.8488 129.301 76.2075L129.581 77.5107C129.597 77.5868 129.609 77.6696 129.617 77.759C129.625 77.8485 129.619 77.9293 129.6 78.0015L128.624 82.9836C128.586 83.2306 128.466 83.4524 128.264 83.6491C128.062 83.8457 127.836 83.9709 127.586 84.0244L120.399 85.5663ZM120.085 77.3494L121.491 83.9003L127.243 82.6662L128.212 77.8043L127.932 76.5012L122.131 77.7459L122.272 74.0337L120.085 77.3494ZM118.509 85.9718C118.129 86.0533 117.777 85.9897 117.454 85.781C117.131 85.5715 116.928 85.2768 116.847 84.8966L115.613 79.1443C115.531 78.7642 115.595 78.4123 115.803 78.0888C116.013 77.7657 116.308 77.5633 116.688 77.4818L118.578 77.0763L118.888 78.4417L116.981 78.8506L118.216 84.6029L120.122 84.194L120.416 85.5628L118.509 85.9718Z",
    fill: "#5E6A7D"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 63,
    width: 47,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 55,
    width: 72,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 42,
    width: 63,
    height: 4,
    rx: 2,
    fill: "#DBEBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6830_23424",
    x1: 144.628,
    y1: -0.259608,
    x2: 30.2303,
    y2: 134.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#ED76AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6830_23424",
    x1: 84,
    y1: 0,
    x2: 84,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForceFeedbackThumbnail);
export default __webpack_public_path__ + "static/media/force-feedback-thumbnail.69c153a8dea6331dc48327152c3bcd5f.svg";
export { ForwardRef as ReactComponent };